<template>
  <div>
    <Header
      parent="clients_base"
      :subparent="{
        route: `/clients_base/${$route.params.id}`,
        content: client_name,
      }"
    />
    <IQOSTable
      :rows="orders"
      :cols="[
        {
          title: '#',
          index: true,
        },
        {
          title: $t('worker_tips_history.col_date'),
          key: 'created_at',
          date: true,
          width: 200,
        },
        {
          title: $t('worker_tips_history.col_time'),
          key: 'created_at',
          time: true,
          width: 160,
        },
        {
          title: $t('subscription.transactions.system'),
          key: 'mode',
          renderer: (row) => formatSystemName(row.mode),
        },
        {
          title: $t('worker_tips_history.col_total'),
          key: 'total',
          width: 160,
          currency: 'symbol',
        },
        {
          title: $t('worker_tips_history.col_discount'),
          key: 'discount',
          default: '0',
          unit: '%',
        },
      ]"
    />
  </div>
</template>

<script>
import StatsAPI from "@/api/stats";

export default {
  data() {
    return {
      orders: [],
      client_name: "...",
    };
  },
  methods: {
    fetchData() {
      StatsAPI.getClientOrdersHistory(
        this.$store.state.cafe._id,
        this.$route.params.id
      )
        .then((data) => {
          this.client_name = data.client.name;
          this.orders = data.orders;
        })
        .catch((err) => {
          this.$store.dispatch("showError", "stats_failed");
        });
    },
    formatSystemName(mode) {
      return {
        inside: "INSIDE",
        preorder: "TAKEAWAY",
        delivery: "DELIVERY",
        reserve: "RESERVE",
        pro: "PRO",
      }[mode];
    },
  },
  mounted() {
    this.fetchData();
  },
};
</script>

<style>
</style>